import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface bookScanLWSalesDataInterface {
  DATE: string, 
  LAST_WEEK_SALES:number;
}

interface bookScanYtdSalesDataInterface {
  DATE:string;
  YTD_SALES:number;
}

interface bookScanLtdSalesDataInterface {
  LTD_SALES: number
}

interface booksacanDataObj {
  lwData:bookScanLWSalesDataInterface,
  ytdData:bookScanYtdSalesDataInterface, 
  ltdData:bookScanLtdSalesDataInterface;
  dataAsOf?: string | null;
}

interface TitleListBookScanState {
  data: booksacanDataObj;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
}
const initialState: TitleListBookScanState = {
  data: {
    lwData:{
      DATE:"",
      LAST_WEEK_SALES:0
    },
    ytdData:{
      DATE:"",
      YTD_SALES:0
    },
    ltdData:{
      LTD_SALES:0
    },
    dataAsOf: null,
  },
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchTitleListBookScanSalesRecord = createAsyncThunk(
  "FetchTitleListBookScanSalesRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.BookScanTITLESALESDATA,data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListBookScanSlice = createSlice({
  name: "TitleListBookScanData",
  initialState,
  reducers: {
    emptyBookscanPosSales:(state) => {
      state.data = initialState.data;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
      state.status = initialState.status;
      state.statusCode = initialState.statusCode;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListBookScanSalesRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListBookScanSalesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data
      })
      .addCase(FetchTitleListBookScanSalesRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const {
  emptyBookscanPosSales
} = TitleListBookScanSlice.actions;
export default TitleListBookScanSlice.reducer;
